"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["DEFAULT"] = "btn btn-semi-bold";
    ButtonStyle["SECONDARY"] = "btn btn-secondary btn-semi-bold btn-borderless";
    ButtonStyle["ACCENT_BORDERLESS"] = "btn btn-accent btn-bold btn-borderless";
    ButtonStyle["SMALL"] = "btn btn-small btn-semi-bold";
    ButtonStyle["ANCHOR"] = "anchor-button";
    ButtonStyle["SMALL_GREY"] = "btn btn-small btn-semi-bold btn-grey";
    ButtonStyle["SMALL_GREY_BORDERLESS"] = "btn btn-small btn-semi-bold btn-grey btn-borderless";
    ButtonStyle["SMALL_WARNING_BORDERLESS"] = "btn btn-small btn-semi-bold btn-warning btn-borderless";
    ButtonStyle["SMALL_ERROR_BORDERLESS"] = "btn btn-small btn-semi-bold btn-error btn-borderless";
})(ButtonStyle || (ButtonStyle = {}));
exports.default = ButtonStyle;
//# sourceMappingURL=ButtonStyle.js.map